<template>
	<div class="reservation-container">
		<div class="formWrap" v-if="false">
			<div class="form-box mainCont">
				<h2>免费预约</h2>
				<el-form :model="form" id="reserForm" :rules="rules" ref="reserForm" class="formBox">
					<el-form-item class="form_item w48" prop="fwfl">
						<p class="laben">服务分类</p>
						<div class="item_input">
							<el-cascader :key="isResouceShow"
							v-model="serverVal" 
							:options="serverList" :props="{value:'id',label:'typeName'}"
							@change="handleChangeServer"></el-cascader>
							
						</div>
					</el-form-item>
					<el-form-item class="form_item w48" prop="productId">
						<p class="laben">服务产品</p>
						<div class="item_input">
							<el-select no-data-text="请先选择服务分类" v-model="form.productId" placeholder="请选择服务分类" :popper-append-to-body="false">
								<el-option
								  v-for="item in list"
								  :key="item.id"
								  :label="item.productName"
								  :value="item.id">
								</el-option>
							</el-select>
						</div>
					</el-form-item>
					<el-form-item class="form_item w48" prop="memberYysj">
						<p class="laben">预约时间</p>
						<div class="item_input">
							<el-date-picker value-format="yyyy-MM-dd HH:mm"  format="yyyy-MM-dd HH:mm" v-model="form.memberYysj" type="datetime" placeholder="请选择时间">
						  </el-date-picker>
						</div>
					</el-form-item>
					<el-form-item class="form_item w48" prop="province">
						<p class="laben">省市区</p>
						<div class="item_input">
							<el-cascader
							:options="optionsThree"
							v-model="selectedThree"
							placeholder="请选择省市区"
							@change="handleChange"
							ref="three"
							></el-cascader>
						</div>
					</el-form-item>
					<el-form-item class="form_item w48" prop="lxdz">
						<p class="laben">详细地址</p>
						<div class="item_input">
							<el-input v-model="form.lxdz" placeholder="请输入详细地址"></el-input>
						</div>
					</el-form-item>
					<el-form-item class="form_item w48" prop="content">
						<p class="laben">问题描述</p>
						<div class="item_input">
							<el-input v-model="form.content" placeholder="请输入问题描述"></el-input>
						</div>
					</el-form-item>
					
					<el-form-item class="form_item w48" prop="mobile">
						<p class="laben">手机号</p>
						<div class="item_input">
							<el-input style="flex: 1;" v-model="form.mobile" type="number" placeholder="请输入手机号"></el-input>
						</div>
					</el-form-item>
					<el-form-item class="form_item w48" prop="msgCode">
						<p class="laben">验证码</p>
						<div class="item_input">
							<el-input v-model="form.msgCode" placeholder="请输入验证码"></el-input>
							<button class="btn" @click="getVCode()">{{vcodeBtnName}}</button>
						</div>
					</el-form-item>
					<el-form-item class="form_item">
						<p class="laben">备注</p>
						<div class="item_input">
							<el-input v-model="form.beizhu" type="textarea" :rows="4" resize="none" placeholder="请输入备注"></el-input>
						</div>
					</el-form-item>
				</el-form>
				<el-button type="primary" class="form_btn" @click="submitForm('reserForm')">提交</el-button>
			</div>
		</div>
		<!-- @closeBtn="closeBtn" -->
		<form-box :closeFlag="false"></form-box>
	</div>
</template>
<script>
	
import {orderCreate,getProductTypeAllList,getProductList,sendMsgCode} from '@/api/api'
import { provinceAndCityData, regionData} from "element-china-area-data";
import formBox from './components/formSend';
export default {
	name: 'reservation',
	components:{formBox},
	data() {
		return {
			serverList: [],//服务分类
			serverVal: [],
			isResouceShow:0,
			list:[],//服务产品
			// 省市区级联
			optionsThree: regionData,
			optionsTwo: provinceAndCityData,
			selectedThree: ["120000", "120100", "120102"],
			selectedTwo: [],
			form:{
				"area": "",//区
				"beizhu": "",//备注
				"city": "",//市
				"content": "",//描述
				"fwfl": "",//服务分类ID
				"fwflInfo": "",//服务分类
				// "img": "",//图片描述
				"lat": "34.74827",//纬度
				"lng": "113.612984",//经度
				"lxdz": "",//联系地址
				"lxrMobile": "",//联系人电话
				"lxrName": "",//联系人名称
				"memberYysj": "",//用户预约时间
				"mobile": "",//报修电话
				"msgCode": "",//验证码
				"msgId": "",//消息ID
				"name": "",//报修人名称
				"productId": "",//产品ID
				"province": "",//省
			},
			rules: {
				fwfl:[
					{ required: true, message: '请选择', trigger: 'blur' },
				],
				productId:[
					{ required: true, message: '请选择', trigger: 'blur' },
				],
				memberYysj: [
					{ required: true, message: '请选择预约时间', trigger: 'blur' },
				],
				province: [
					{ required: true, message: '请选择', trigger: 'blur' },
				],
				mobile: [
					{ required: true, message: '请输入报修电话', trigger: 'blur' },
				],
				lxdz: [
					{ required: true, message: '请输入详情地址', trigger: 'blur' },
				],
				msgCode: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				content: [
					{ required: true, message: '请输入', trigger: 'blur' },
				],
			},
			vcodeBtnName:'获取验证码',
			countNum : 120,
			countDownTimer : null,
		};
	},
	mounted() {
		console.log('111999')
		this.getProductTypeList();
	},
	methods: {
		//分类列表
		getProductTypeList(){
			getProductTypeAllList({flType:1,}).then(res => {
				console.log(res)
				let list = res.data;
				list.forEach(ele=>{
					ele.children.forEach(item=>{
						delete item.children
					})
				})
				this.serverList = list;
				this.isResouceShow = '665'
			})
		},
		// 服务分类---选择
		handleChangeServer(e){
			console.log(e)
			this.form.fwfl = e[1];
			// getProductList
			let productTypeId = e[1];
			getProductList({pageIndex: 1,pageSize: 100,productTypeId: productTypeId}).then(res => {
				console.log(res)
				let list = res.data;
				this.list = list;
			})

		},
		 /**省市区三级联动 */
		 handleChange() {
			// console.log(this.selectedThree);
			// console.log(this.$refs.three.getCheckedNodes()[0].pathLabels);
			let arr = this.$refs.three.getCheckedNodes()[0].pathLabels
			this.form.province = arr[0];
			this.form.city = arr[1];
			this.form.area = arr[2];
		},
		// 获取验证码
		getVCode(){
			var myreg=/^[1][0-9]{10}$/;
			if (!myreg.test(this.form.mobile)){
				this.$message({
				message: '请正确填写手机号码',
				type: 'warning'
				});
				return false;
			}
			// 手机号码为 :  this.phoneno
			// vcodeBtnName 可以阻止按钮被多次点击 多次发送 return 会终止函数继续运行
			if (this.vcodeBtnName != '获取验证码' && this.vcodeBtnName != '重新发送'){return ;}
			this.vcodeBtnName =  "发送中...";
			// 倒计时
			this.countNum = 60;
			this.countDownTimer = setInterval(function(){this.countDown();}.bind(this), 1000);
			// 与后端 api 交互，发送验证码
			const loading = this.$loading({
			lock: true,
			text: 'Loading',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
			});
			sendMsgCode({mobile:this.form.mobile}).then(res => {
				loading.close();
				console.log(res)
				if(res.flag){
					this.form.msgId = res.data;
					this.$message(res.msg|| '短信已发送，请注意查收');
					// this.code = res.result
				}else{
					clearInterval(this.countDownTimer);
					this.$message(res.msg);
					this.vcodeBtnName =  "重新发送";
				}
				
			})
		},
		// 倒计时
		countDown(){
			if (this.countNum < 1){
				clearInterval(this.countDownTimer);
				this.vcodeBtnName = "重新发送";
				return ;
			}
			this.countNum--;
			this.vcodeBtnName =  this.countNum + '秒重发';
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// lxrName 姓名
					let formData = {...this.form}
					formData.lxrMobile = formData.mobile;
					console.log(this.form)
					formData.memberYysj = '2024-07-30 20:38-21:30'
					formData.lxrName = 'PC';
					formData.name = "PC";
					// return false
					orderCreate(formData).then(res => {
						if(res.flag){
							this.$message({
								message: res.msg,
								type: 'success'
							});
						}else{
							this.$message(res.msg);
						}
						
					})
				}
			});
		},
	},
};
</script>
<style lang="scss">
.reservation-container{background-color: #F5F8F9;padding-top:24px;
	.formWrap{position: relative;
		.form-box{width: 1012px;min-height: 698px;background: #FFFFFF;border-radius: 20px;padding: 40px 66px 48px;margin: 26px auto 44px;position: relative;
			.closeIcon{position: absolute;top: 30px;right: 30px;color: #A4A9B7;
				i{font-size: 26px;cursor: pointer;transition: all .3s;
					&:hover{color: red;}
				}
			}
			h2{color: #292A2C;font-size: 30px;font-weight: bold;margin-bottom: 30px;}
			.formBox{display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;
				.form_item{width: 100%;margin-bottom: 24px;
					&.w48{width: 48.86%;}
					.laben{color: #1F263F;font-size: 14px;margin-bottom: 8px;}
					.item_input{position: relative;width: 100%;display: flex;align-items: center;
						.el-select,.el-input{width: 100%;border-radius: 10px;
							.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
						}
						.el-date-editor{width: 100%;border-radius: 10px;
							.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
						}
						.el-cascader{width: 100%;
							.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
						}
						.btn{width: 102px;height: 50px;background: #2F78FF;border-radius: 5px;padding: 0;border: 0;color:#fff;font-size: 14px;margin-left: 8px;cursor: pointer;}
					}
					.item_inputs{position: relative;display: flex;align-items: center;justify-content: space-between;
						.el-select{width: 170px;
							.el-input__inner{border-radius: 5px;height: 50px;line-height: 50px;}
						}
					}
				}
			}
			.form_btn{width: 350px;height: 60px;background: #2F78FF;border-radius: 5px;padding: 0;border: 0;color:#fff;font-size: 16px;margin: 24px auto 0;cursor: pointer;display: block;}
		}
	}
	
}
</style>


// WEBPACK FOOTER //
// src/views/reservation/index.vue